import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Selected",
  "use": "Selected-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\" id=\"Selected\"><path clip-rule=\"evenodd\" d=\"M10 22.5C10 15.6 15.6 10 22.5 10S35 15.6 35 22.5 29.4 35 22.5 35 10 29.4 10 22.5Zm3.75 0L20 28.75 31.25 17.5l-1.762-1.775L20 25.212l-4.488-4.474L13.75 22.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol